import { IconProps } from '../types';
import Theme from '../../../components-library/Theme';

export default function PickupIcon({ color, className }: IconProps) {
  return (
    <svg className={className ?? 'h-6 w-6'} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.17773 4.5L13.3223 4.5C14.0488 4.50012 14.6633 5.01903 14.7959 5.71973L14.8154 5.8623L15.5518 13.8623C15.6326 14.7413 14.9403 15.5 14.0576 15.5L2.44238 15.5C1.61505 15.5 0.955283 14.8337 0.942383 14.0264L0.948242 13.8623L1.68457 5.8623C1.75572 5.09061 2.40276 4.50012 3.17773 4.5Z"
        stroke={color ?? Theme.color.gray['700']}
      />
      <path
        d="M11.4997 7.13402V4.06723C11.4997 2.37325 10.1264 1 8.43246 1V1C6.73848 1 5.36523 2.37324 5.36523 4.06723V7.13402"
        stroke={color ?? Theme.color.gray['700']}
      />
      <ellipse cx="5.36536" cy="8.38481" rx="1.11536" ry="1.11528" stroke={color ?? Theme.color.gray['700']} />
      <ellipse cx="11.5021" cy="8.38481" rx="1.11536" ry="1.11528" stroke={color ?? Theme.color.gray['700']} />
    </svg>
  );
}
